module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/marquee_mobile4-00e6a51fe4e959e4a78da8b8be30372e.jpg";